module.exports = __webpack_public_path__ + "static/media/intent-registry-image.95fc89c3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/onboard/intent-registry-image.svg
// module id = 1515
// module chunks = 50